import { render, staticRenderFns } from "./mainAuth.vue?vue&type=template&id=55066c9e&"
import script from "./mainAuth.vue?vue&type=script&lang=js&"
export * from "./mainAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports